import HttpService from './HttpService';

class InsuranceService {
    async getHousePolicies(houseId) {
        const response = await HttpService.get(`/houses/${houseId}/insurance`);
        return response.data;
    }

    async getPolicy(policyId) {
        const response = await HttpService.get(`/insurance/${policyId}`);
        return response.data;
    }

    async createPolicy(houseId, policyData) {
        const response = await HttpService.post(`/houses/${houseId}/insurance`, policyData);
        return response.data;
    }

    async updatePolicy(policyId, policyData) {
        const response = await HttpService.put(`/insurance/${policyId}`, policyData);
        return response.data;
    }

    async deletePolicy(policyId) {
        const response = await HttpService.delete(`/insurance/${policyId}`);
        return response.data;
    }
    
    async scanDocument(file) {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('extraction_type', 'insurance');

        // Don't set Content-Type manually — Axios/browser must inject the boundary parameter.
        const response = await HttpService.post('/smart-scan', formData);
        return response.data;
    }
}

export default new InsuranceService();
